$(document).on('click', '.flip-action', function(){
  var cardshowflag= $(this).attr("data-val");
  var discount= $(this).attr("data-discount");
  var targetElement = $(this).closest('.card');
  var menuItemSlug = $(this).children('#menuItemSlug').val();
  var venueSlug = $(this).children('#venueSlug').val();
  var baseUrl = $('#base_url_discountFlip').val();
  addItemFlip(targetElement, cardshowflag,discount,menuItemSlug,venueSlug,baseUrl);
 // targetElement.addClass('flipped');

  $(targetElement).find('.front').css("transform", "rotateY(-180deg) translateZ(1px)");
      
  var clickedEl = $(this);
    setTimeout(function(){
      $(targetElement).find('.back').css("transform", "rotateY(0deg)  translateZ(1px)");
  }, 200);

});
$(document).on('click', '.flip-back-action', function(){
  // $(this).closest('.card').removeClass('flipped')
  var targetElement = $(this).closest('.card');
   targetElement.find('.back').css("transform", "rotateY(-180deg)  translateZ(1px)");
    
   targetElement.find('.front').css("transform", "rotateY(0deg)  translateZ(1px)");
});

function addItemFlip(element, data,discount,menuItemSlug,venueSlug,baseUrl) {
  console.log("addItemFlip...",JSON.stringify(discount));
  if(element.find('.face.back').length > 0) {
    return;
  }
  let discountdiv='';
  let totalvalue=0;
  let customerRatingRestaurantVal=0;
 
  discount = JSON.parse(discount);
//ugly hack 3=4-2
  if( discount.customerRatingRestaurant ) {
		customerRatingRestaurantVal = discount.customerRatingRestaurant ; 
	}
  if (discount.customerFirstTimeOrder && Number(discount.customerFirstTimeOrder) > 0) {
     discountdiv=`
     		<div class="form-row flipformbox" id="customerFirstTimeOrder_div">
					<div class="col-3 col-md-4 right-section-column pl-1 pr-1">
						<div class="discount-center">
              <span class="main-info-orange font-18 pl-1">+`+discount.customerFirstTimeOrder.toFixed(0)+`%</span>
						</div>
					</div>
					<div class="col-9 col-md-8 right-section-column pl-1 pr-1 text-left">
						<p class="right-info-text">Your first order from this restaurant</p>
					</div>
				</div>
     `
      totalvalue += Number(discount.customerFirstTimeOrder)
  }
  if (discount.customerFirstMenuItemRating && Number(discount.customerFirstMenuItemRating) > 0) {
      discountdiv += `
										<div class="form-row flipformbox" id="customerFirstMenuItemRating_div">
											<div class="col-3 col-md-4 right-section-column pl-1 pr-1">
												<div class="discount-center">
													<span class="main-info-orange font-18 pl-1">+`+discount.customerFirstMenuItemRating.toFixed(0)+`% </span>
												</div>
											</div>
											<div class="col-9 col-md-8 right-section-column pl-1 pr-1 text-left">
												<p class="right-info-text">Your first rating of incentivized items</p>
											</div>
										</div>
      `
      totalvalue += Number(discount.customerFirstMenuItemRating)
  }
  if (customerRatingRestaurantVal && Number(customerRatingRestaurantVal) > 0) {
      discountdiv += `
										<div class="form-row flipformbox" id="customerRatingRestaurant_div">
											<div class="col-3 col-md-4 right-section-column pl-1 pr-1">
												<div class="discount-center">
													<span class="main-info-orange font-18 pl-1">+`+customerRatingRestaurantVal.toFixed(0)+`% </span>
												</div>
											</div>
											<div class="col-9 col-md-8 right-section-column pl-1 pr-1 text-left">
												<p class="right-info-text">If you’re the first ever to rate this item</p>
											</div>
										</div>
      `
      totalvalue += Number(customerRatingRestaurantVal)
  }
  
  if (discount.customerFirstExpertReview && Number(discount.customerFirstExpertReview) > 0) {
      discountdiv += `
										<div class="form-row flipformbox" id="customerFirstExpertReview_div">
											<div class="col-3  col-md-4 right-section-column pl-1 pr-1">
												<div class="discount-center">
													<span class="main-info-orange font-18 pl-1">`+"+" + discount.customerFirstExpertReview.toFixed(0)+`% </span>
												</div>
											</div>
											<div class="col-9 col-md-8 right-section-column pl-1 pr-1 text-left">
												<p class="right-info-text"> First detail review ever of this item</p>
											</div>
										</div>
      `
      totalvalue += Number(discount.customerFirstExpertReview)
  }

  element.append(
    `<div class="face back">
      <div id="imageCredits" class="text-center flip-back-action">
					<div class="" id="earn_discount">
						<div class="modal-dialog">
						<span class="rateheading white">Free food credits you can earn</span>
            <button type="button" class="flip-back-action white font-18" data-dismiss="modal" style="background-color: transparent!important;">×</button>
							<div class="p-3">
									<div class="earn-bg2">
										${discountdiv}
									</div>
									<div class="row mt-2 mb-2">
											<div class="col-md-12 col-12">
												<a href="/unique" class="text-link-flip"><span class="font-13 white">Other reasons to use PlateRate</span></a>
											</div>
									</div>
									<div class="modal-footer">
										<div class="row">
											<div class="bottom-arrow flip-back-action text-center">
												<i class="fa fa-arrow-right"></i>
										</div>
									</div>
								</div>
						</div>
					</div>
				</div>
    </div>`
  );
  
}

